const {
  getMediaCoreAndVerifyDeviceStreamsStatus,
  getRecordingAsBlob,
  getFormattedRecordingUrls
} = require('cloud-utils/helpers/recording-stream-helpers')

angular
  .module('surfsightApp.controllers')
  .controller('recordingVideoControllerDeprecated', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    '$filter',
    '$http',
    '$mdToast',
    '$mdColors',
    '$localStorage',
    function (
      $rootScope,
      $scope,
      $timeout,
      $interval,
      $filter,
      $http,
      $mdToast,
      $mdColors,
      $localStorage
    ) {
      $scope.hoveringVideoElement = false
      $scope.continueVideoElement = false
      $scope.recordingVideoElementToggle = false
      const recordingVideoDuration = 30
      let recordingVideoTrackerTimer
      let mediaToken = $scope.recordingData.mediaToken
      let edgeTime = $scope.recordingData.nearestLocation.time
      const {
        serialNumber,
        streamId,
        recordingStreamQuality
      } = $scope.recordingData
      const videoElementId = `remoteVideos-${serialNumber}-${streamId}`
      $scope.displayOptions = {
        showDisplayOptions: true,
        fullScreen: true,
        playPause: true,
        closeVideo: true,
        ...($scope.recordingData.displayOptions || {})
      }
      const streamName = window.getCameraNameByStreamId(
        $filter('translate'),
        $scope.recordingData.edge,
        streamId
      )
      $scope.recStreamDisplay = {
        serialNumber,
        cameraName: $scope.recordingData.edge.name || serialNumber,
        streamId,
        streamName
      }
      $scope.playerStatus = {
        playStatus: false,
        fullScreen: false
      }
      $scope.videoElementId = videoElementId
      let recordingAbortController
      const initPlayerControls = async () => {
        recordingAbortController && recordingAbortController.abort()
        recordingAbortController = new window.AbortController()
        try {
          const {
            deviceStreamsStatus,
            mediacore
          } = await getMediaCoreAndVerifyDeviceStreamsStatus(
            MEDIACORE_BASEURL,
            serialNumber,
            mediaToken,
            recordingAbortController
          )
          if (!deviceStreamsStatus) {
            throw new Error('Device offline')
          }
          const { videoSrc } = getFormattedRecordingUrls(
            mediacore,
            mediaToken,
            {
              serialNumber,
              streamId,
              startTime: edgeTime,
              duration: recordingVideoDuration,
              quality: recordingStreamQuality.value
            }
          )
          if ($rootScope.browserInfo.config.isSafari) {
            const blob = await getRecordingAsBlob(
              videoSrc,
              recordingAbortController
            )
            $scope.recvideoSource = window.URL.createObjectURL(blob)
          } else {
            $scope.recvideoSource = videoSrc
          }
          $scope.recordingVideoElementToggle = true
          $timeout(() => {
            applyRecordingPlaybackSpeed()
            initPlayerTracking()
            playPauseVideo()
          }, 500)
          $scope.$apply()
        } catch (ex) {
          console.log(ex)
          return alert('Unable to play recording timeline')
        }
      }
      let fullScreenTracker
      const goFullScreen = () => {
        try {
          const element = document.getElementById(`${videoElementId}-container`)
          for (const fullScreenProp of [
            'requestFullscreen',
            'mozRequestFullScreen',
            'webkitRequestFullscreen',
            'webkitEnterFullScreen',
            'msRequestFullscreen'
          ]) {
            if (element[fullScreenProp]) {
              element[fullScreenProp]()
              fullScreenTracker = $interval(() => {
                const currentFullScreenState =
                  document.fullScreen ||
                  document.mozFullScreen ||
                  document.webkitIsFullScreen ||
                  document.webkitFullscreenElement
                if (!currentFullScreenState) {
                  fullScreenTracker && $interval.cancel(fullScreenTracker)
                  fullScreenTracker = null
                  $scope.playerStatus.fullScreen = false
                }
              }, 1000)
            }
          }
        } catch (e) {
          console.error(e)
        }
      }
      const exitFullScreen = () => {
        for (const exitFullScreenProp of [
          'exitFullscreen',
          'mozCancelFullScreen',
          'webkitExitFullscreen',
          'msExitFullscreen'
        ]) {
          if (document[exitFullScreenProp]) {
            document[exitFullScreenProp]()
            break
          }
        }
      }
      const toggleFullScreen = () => {
        const currentFullScreenState =
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen ||
          document.webkitFullscreenElement
        if (currentFullScreenState) {
          exitFullScreen()
          $scope.playerStatus.fullScreen = false
        } else {
          goFullScreen()
          $scope.playerStatus.fullScreen = true
        }
      }
      const applyRecordingPlaybackSpeed = () => {
        const element = document.getElementById(videoElementId)
        if (element) {
          element.playbackRate = recordingStreamQuality.playbackRate
        }
      }
      const playPauseVideo = () => {
        if ($scope.continueVideoElement) return continueRecording()
        $scope.continueVideoElement = false
        const element = document.getElementById(videoElementId)
        $scope.playerStatus.playStatus = element.paused
        if (!element.ended) {
          $scope.playerStatus.playStatus ? element.play() : element.pause()
        }
      }
      const continueRecording = () => {
        $scope.continueVideoElement = false
        clearVideoSrc()
        $timeout(() => {
          $scope.recordingVideoElementToggle = false
          edgeTime += recordingVideoDuration // next recording video start time
          initPlayerControls()
        })
      }
      const initPlayerTracking = () => {
        stopPlayerTracking()
        recordingVideoTrackerTimer = $interval(trackPlayerTime, 2000)
      }
      const stopPlayerTracking = () => {
        recordingVideoTrackerTimer &&
          $interval.cancel(recordingVideoTrackerTimer)
      }
      const trackPlayerTime = () => {
        const element = document.getElementById(videoElementId)
        if (!$scope.playerStatus.playStatus) {
          !element.paused && element.pause()
          return
        }
        console.warn(element.currentTime, element.ended)
        if (
          $scope.playerStatus.playStatus &&
          (Math.round(element.currentTime) >= recordingVideoDuration ||
            (Math.round(element.currentTime) >= recordingVideoDuration - 2 &&
              element.ended))
        ) {
          playPauseVideo()
          $scope.continueVideoElement = true // Show continue video message in the player
          stopPlayerTracking()
        }
      }
      const clearVideoSrc = () => {
        const video = document.getElementById(videoElementId)
        if (video) {
          video.src = ''
          video.load()
        }
      }
      $scope.closeRecordingVideo = () => {
        clearVideoSrc()
        $scope.closeVideo($scope.recordingData)
      }
      $scope.toggleFullScreen = toggleFullScreen
      $scope.playPauseVideo = playPauseVideo
      $scope.continueRecording = continueRecording
      $timeout(initPlayerControls, 300)
      $scope.$on('updateMediaToken', (e, data) => {
        mediaToken = data.mediaToken // update media token
      })
      $scope.$on('$destroy', function () {
        clearVideoSrc()
        stopPlayerTracking()
        fullScreenTracker && $interval.cancel(fullScreenTracker)
        recordingAbortController && recordingAbortController.abort()
      })
    }
  ])
